module.exports = __webpack_public_path__ + "img/accident-check.30e04268.svg";